module.exports = __webpack_public_path__ + "assets/images/premium-features/labor-percentage-55c3f0.png";